import { Dropdown, DropdownOption, TableCell, Typography } from '@vp/swan';

import React from 'react';
import PropTypes from 'prop-types';

export const DebugExperimentsControls = ({
  experimentKey,
  variationKey = 'NONE',
  availableVariationKeys,
  overrideExperiment,
}) => (
  <>
    <TableCell>
      <Typography fontSize="small">{experimentKey}</Typography>
    </TableCell>
    <TableCell>
      <Dropdown
        value={variationKey}
        onChange={event => {
          let selectedVariationKey = event.target.value;
          if (selectedVariationKey === 'NONE') {
            selectedVariationKey = undefined;
          }
          overrideExperiment({
            experimentKey,
            variationKey: selectedVariationKey,
            availableVariationKeys,
          });
        }}
        size="mini"
      >
        <DropdownOption value="NONE">None Selected</DropdownOption>
        {availableVariationKeys.map((variation, index) => (
          <DropdownOption value={variation} key={index}>
            {variation}
          </DropdownOption>
        ))}
      </Dropdown>
    </TableCell>
  </>
);

DebugExperimentsControls.propTypes = {
  experimentKey: PropTypes.string.isRequired,
  variationKey: PropTypes.string,
  availableVariationKeys: PropTypes.array.isRequired,
  overrideExperiment: PropTypes.func.isRequired,
};
